import { useQuery, UseQueryResult } from "react-query";
import { useAuth } from "../../sdk/hooks";
import * as scheduleApi from "../../sdk/utils/api/price-change-schedule";
import { IPriceChangeScheduleListPage } from "../../sdk/utils/api/price-change-schedule";

export const useGetAllSchedules = (
    queryKey: string | string[],
    params?: { limit?: number; cursor?: string; direction?: string; status?: number }
): UseQueryResult<IPriceChangeScheduleListPage> => {
    const { token } = useAuth();

    return useQuery<IPriceChangeScheduleListPage>(
        queryKey,
        async () => {
            if (!token) throw new Error("Not authenticated");
            return await scheduleApi.getAllSchedules(token, params);
        },
        { keepPreviousData: true }
    );
};
